module.exports = __webpack_public_path__ + "media/images/pillar_sales-516fba88b92c82b9bc8db11d2849cd79.jpg";